import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {PriceRobotFilter} from "./price-robot-filter";
import {PriceRobotProduct} from "./price-robot-product";
import {environment} from "../../environments/environment";
import {ApiResponse, AuthService, BaseService} from "@hassel-it/angular-common";
import {map} from "rxjs/operators";
import {Observable} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class PriceRobotProductsService extends BaseService {

    constructor(public http: HttpClient, public authService: AuthService) {
        super(http, authService);
    }

    index(page: number, filter: PriceRobotFilter = new PriceRobotFilter()): Observable<ApiResponse> {
        this.reloadHeaders();

        let myParams = this.buildQuery(filter);
        myParams = myParams.append('page', page);
        return this.http.get(environment.apiBase + '/api/tenfour-crawler/products', {
            headers: this.httpHeaders,
            params: myParams
        }).pipe(map((response: any) => {
            const data = response.products
                .map((json: any): PriceRobotProduct => {
                    return PriceRobotProduct.customFromJSON(json);
                });
            return new ApiResponse(data, response.meta.Products.count);
        }))
    }

    buildQuery(filter: PriceRobotFilter) {
        let myParams = new HttpParams();
        myParams = myParams.append('sort', filter.sort);
        myParams = myParams.append('direction', filter.direction);

        myParams = myParams.append('robotStatus', filter.robotStatus);
        myParams = myParams.append('webActive', filter.webActive);
        myParams = myParams.append('campaignStatus', filter.campaignStatus);

        if (filter.urlStatus) {
            myParams = myParams.append('urlStatus', filter.urlStatus);
        }

        if (filter.sendingStatus) {
            myParams = myParams.append('sendingStatus', filter.sendingStatus);
        }

        if (filter.variantIds) {
            myParams = myParams.append('variantIds', filter.variantIds.join(','));
        }

        if (filter.categoryIds) {
            myParams = myParams.append('categoryIds', filter.categoryIds.join(','));
        }

        if (filter.query) {
            myParams = myParams.append('query', filter.query);
        }

        if (filter.currentUser) {
            myParams = myParams.append('user', this.authService.currentUser.id);
        } else {
            myParams = myParams.append('user', filter.user);
        }

        if (filter.minPrice !== 0 && filter.minPrice.toString() !== '0' && filter.minPrice.toString() !== '') {
            myParams = myParams.append('minPrice', filter.minPrice);
        }

        if (filter.maxPrice !== 0 && filter.maxPrice.toString() !== '0' && filter.maxPrice.toString() !== '') {
            myParams = myParams.append('maxPrice', filter.maxPrice);
        }

        if (filter.minDeviation !== 0 && filter.minDeviation.toString() !== '0' && filter.minDeviation.toString() !== '') {
            myParams = myParams.append('minDeviation', filter.minDeviation);
        }

        if (filter.maxDeviation !== 0 && filter.maxDeviation.toString() !== '0' && filter.maxDeviation.toString() !== '') {
            myParams = myParams.append('maxDeviation', filter.maxDeviation);
        }
        if (filter.selectedPriceCategory && filter.selectedPriceCategory !== 'none') {
            myParams = myParams.append('selectedPriceCategory', filter.selectedPriceCategory);
        }

        return myParams;
    }

    view(id: number): Observable<PriceRobotProduct> {
        this.reloadHeaders();

        return this.http.get(environment.apiBase + '/api/tenfour-crawler/products/' + id, {headers: this.httpHeaders})
            .pipe(map((response: any) => {
                return PriceRobotProduct.customFromJSON(response.product);
            }))
    }

    rescan(id, force: boolean = false, crawler_website_id:number=null) {
        this.reloadHeaders();

        return this.http.post(environment.apiBase + '/api/tenfour-crawler/products/' + id + '/rescan',
            {force: force, crawler_website_id},
            {headers: this.httpHeaders})
            .pipe(map((response: any) => {
                return PriceRobotProduct.customFromJSON(response.product);
            }))
    }
}
